export const Back = ({ scale = 1 }: { scale?: number }) => {
  return (
    <svg
      width={16 * scale}
      height={16 * scale}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.8536 2.64649C8.04884 2.84178 8.0488 3.15836 7.85351 3.3536L3.70703 7.49905L13.5001 7.5014C13.7763 7.50147 14.0001 7.72538 14 8.00152C13.9999 8.27766 13.776 8.50147 13.4999 8.5014L3.70719 8.49905L7.8536 12.6465C8.04884 12.8418 8.0488 13.1584 7.85351 13.3536C7.65822 13.5488 7.34164 13.5488 7.1464 13.3535L2.1464 8.35227C2.05265 8.25849 1.99998 8.13131 2 7.9987C2.00002 7.86609 2.05271 7.73892 2.14649 7.64517L7.14649 2.6464C7.34178 2.45116 7.65836 2.4512 7.8536 2.64649Z"
        fill="black"
      />
    </svg>
  );
};
